import React from 'react'
import Textarea from '../../Textarea/Textarea'
import { FieldArray, useField } from 'formik'
import { getFieldValidationErrorMessageDOM, AddInstanceButton, ContextualDropdown, isFieldMultiple, contextualDropdownActionArray, ReadOnlyField, SuggestWithAi } from '../helper'
import { modeTypes } from '../constants'

const MultipleInstance = ({ field, fieldWidth, mode }) => {
  const { formFieldUid } = field;

  const isReadOnly = mode === modeTypes.readOnly || field.readOnly

  const [multilineFields, multilineMeta] = useField(formFieldUid);

  return <FieldArray name={formFieldUid}>
    {({ insert, remove, move, push }) => {
      return <div data-test-id={`cs-asset-details-field-${formFieldUid}-multiple-instance-wrapper`}>
        {multilineFields?.value?.map?.((item, index) => (
          <div className='asset-details-v2-fields-container__multiline-text-container__item' key={index} data-test-id={`cs-asset-details-field-${formFieldUid}-multiple-instance-item-${index}-wrapper`}>
            <div className={`asset-details-v2-fields-container__multiline-text-container__item__input-container ${(field?.maxLength && field?.showCharacterCount) ? 'adjust-margin-top' : ''} ${(field?.errorMessage?.[index]) ? 'adjust-margin-left' : ''} `}>
              <div className='growContainer'>
                {isReadOnly ? <ReadOnlyField width={fieldWidth} showCopyIcon={field.showCopyIcon} value={item} copyLabel={field.title} copyIconSize={'small'} testId={`${formFieldUid}.${index}`} copyContent={isReadOnly ? item : ''} />
                  : <Textarea
                    id={`${field.uid}-text-area-${index}`}
                    placeholder={field.placeholder || ''}
                    // className={field.className || ''}
                    testId={`cs-asset-details-field-${formFieldUid}-multiple-instance-item-${index}-input`}
                    version={'v2'}
                    width={fieldWidth}
                    maxLength={field?.maxLength}
                    showCharacterCount={field?.showCharacterCount}
                    {...multilineFields}
                    value={item || ''}
                    name={`${formFieldUid}.${index}`}
                    error={multilineMeta.touched && multilineMeta.error?.[index]}
                  />}
              </div>
              {!isReadOnly && <ContextualDropdown contextualDropdownActionArray={contextualDropdownActionArray(field, index, remove)} field={field} />}
            </div>
            {Array.isArray(multilineMeta.error)
              ? getFieldValidationErrorMessageDOM(multilineMeta, index, undefined, `cs-asset-details-field-${formFieldUid}-multiple-instance-item-${index}-validation-message`)
              : null}
          </div>
        ))}
        {typeof multilineMeta.error === 'string' && getFieldValidationErrorMessageDOM(multilineMeta, undefined, undefined, `cs-asset-details-field-${formFieldUid}-multiple-instance-validation-message`)}
        <div>
          {!isReadOnly && field.multiple && <AddInstanceButton field={field} valueLength={multilineFields?.value?.length} push={push} />}
        </div>
      </div>
    }}
  </FieldArray>
}

const MultilineText = (props: any) => {
  const { field, fieldWidth, mode } = props
  const boundaryRef = React.useRef<HTMLDivElement>(null)
  const { formFieldUid } = field;

  const [multilineField, multilineMeta] = useField(formFieldUid);
  const isMultiple = isFieldMultiple(field);
  const isReadOnly = mode === modeTypes.readOnly || field.readOnly
  return (
    <div ref={boundaryRef} className='asset-details-v2-fields-container__multiline-text-container' data-test-id={`cs-asset-details-field-${field?.formFieldUid}-wrapper`}>
      {isMultiple
        ? <MultipleInstance field={field} fieldWidth={fieldWidth} mode={mode} />
        : <div className='asset-details-v2-fields-container__multiline-text-container__item'>
          <div>
            {isReadOnly ? <ReadOnlyField width={fieldWidth} showCopyIcon={field.showCopyIcon} value={multilineField.value} copyLabel={field.title} copyIconSize={'small'} testId={field.formFieldUid} copyContent={isReadOnly ? multilineField.value : ''} />
              : <Textarea
                id={`${field.uid}-text-area`}
                placeholder={field.placeholder || ''}
                // className={field.className || ''}
                testId={`cs-asset-details-field-${field?.formFieldUid}-input`}
                version={'v2'}
                width={fieldWidth}
                maxLength={field?.maxLength}
                {...multilineField}
                value={multilineField.value || ''}
                showCharacterCount={field?.showCharacterCount}
                error={multilineMeta.touched && multilineMeta.error}
              />}
          </div>
          {getFieldValidationErrorMessageDOM(multilineMeta, undefined, undefined, `cs-asset-details-field-${field?.formFieldUid}-validation-message`)}
          {(!isReadOnly && (field?.enableAiSuggestion || field?.aiUnavailable)) && <SuggestWithAi field={field} AiSuggestionComponent={field?.AiSuggestionComponent} updateValue={multilineField.onChange} boundaryRef={boundaryRef} unavailable={field?.aiUnavailable} unavailableMessage={field?.aiUnavailableMessage} />}
        </div>}
    </div>
  )
}

export default MultilineText